import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const SqlEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="SQL Editor for Android — Write & Run SQL Queries on Your Phone | Cosmovex"
    metaDescription="Full SQL editor for Android. Write queries, manage SQLite tables, browse data, export CSV — all offline on your phone. Free on Google Play."
    ogTitle="SQL Editor for Android — SQLVEdit"
    h1="SQL Editor for Android"
    intro="Write and run SQL queries on your Android phone with a full-featured SQL editor. SQLVEdit lets you create and manage SQLite databases, build queries with syntax highlighting, and inspect results — without needing a laptop."
    paragraphs={[
      "Mobile developers often need to verify a database schema or check data integrity while away from their desk. SQLVEdit gives you a proper SQL editor on Android: write SELECT, INSERT, UPDATE, and DELETE statements, run them against a local SQLite database, and see the results in a clean table view — all on your phone.",
      "The query builder supports the full SQLite syntax including JOINs, subqueries, window functions, and aggregations. Syntax highlighting marks keywords, table names, and string literals so the structure of complex queries stays readable. Autocomplete suggests table and column names after you open a database, cutting down on typos.",
      "Table management is built in. You can create new tables with a column editor, add indexes, rename columns, and drop tables — all through a touch-friendly UI or raw SQL, whichever you prefer. The schema view shows column types, constraints, and foreign keys at a glance.",
      "SQLVEdit is particularly useful for Android developers debugging their app's local database. Export a copy of your app's SQLite file, open it in SQLVEdit, and you can query it exactly as the app would — checking for missing records, wrong data types, or unexpected nulls without setting up a desktop tool.",
    ]}
    features={[
      "Full SQL editor with syntax highlighting and autocomplete",
      "Create, open, and manage SQLite database files",
      "Run SELECT, INSERT, UPDATE, DELETE, and DDL statements",
      "Results displayed in a paginated, sortable table",
      "Table browser with schema details and row counts",
      "Create and drop tables with a visual column editor",
      "Add and manage indexes for performance tuning",
      "Export query results to CSV",
      "Works fully offline — no cloud required",
      "Open .db and .sqlite files from any file manager",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.sqlvedit"
    icon="/images/sqlvedit.png"
    appName="SQLVEdit"
    accentColor="#A8720E"
    canonicalPath="/sql-editor-android"
  />
);

export default SqlEditorAndroid;
